import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchColorStyle({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#k9eokdzmwa)">
                <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M8.454 4.424a1.055 1.055 0 0 1 1.451-.019c.933.982 5.47 5.908 5.47 8.697 0 3.115-2.775 5.648-6.188 5.648C5.776 18.75 3 16.217 3 13.101c0-2.99 5.231-8.446 5.454-8.677zm5.624.001c.422-.396 1.052-.397 1.453-.02.932.982 5.47 5.907 5.47 8.696 0 3.115-2.776 5.649-6.188 5.649-.475 0-.934-.053-1.377-.147.427-.284.82-.61 1.172-.972.07.004.135.018.205.018 2.79 0 5.062-2.04 5.062-4.548 0-1.945-3.262-5.922-5.061-7.836-.342.36-.83.897-1.37 1.537a34.634 34.634 0 0 0-.707-.89 36.632 36.632 0 0 1 1.341-1.487zm-4.89.84C7.819 6.7 4.126 11.02 4.126 13.102c0 2.508 2.271 4.548 5.063 4.548 2.79 0 5.062-2.04 5.062-4.548 0-1.946-3.261-5.924-5.061-7.837z"/>
            </g>
            <defs>
                <clipPath id="k9eokdzmwa">
                    <path fill="#fff" transform="translate(3 3)" d="M0 0h18v18H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconSearchColorStyle;
